import easypayEmployeeMapping, { EasypayEmployeeMappingState } from './easypay-employee-mappings/easypay-employee-mapping.store';
import easypayImportFileBatch from './easypay-import-file-batches/easypay-import-file-batch.store';
import easypayImportFile, { EasypayImportFileState } from './easypay-import-files/easypay-import-file.store';

import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';

export interface LpifState {
   easypayEmployeeMapping?: EasypayEmployeeMappingState;
   easypayImportFile?: EasypayImportFileState;
}

const LpifStore: Module<LpifState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {},
   modules: {
      easypayEmployeeMapping,
      easypayImportFileBatch,
      easypayImportFile,
   },
};

export default LpifStore;
